/** Synchronous reservation prevents overlapping React effects from starting one cue twice. */
export class HostPlaybackAttempts {
  readonly #attempted = new Set<string>();

  /** A rejected autoplay attempt may retry on the next user gesture. */
  release(key: string): void { this.#attempted.delete(key); }

  claim(key: string): boolean {
    if (this.#attempted.has(key)) return false;
    this.#attempted.add(key);
    return true;
  }
}

export function canStartHostPlayback(input: {
  enabled: boolean;
  paused: boolean;
  identity: string;
  sourceIdentity: string | null;
}): boolean {
  return input.enabled && !input.paused && input.identity.length > 0 && input.sourceIdentity === input.identity;
}
